import React, { useEffect, useState } from 'react';
import { getDashboardStats } from '../../api/agentApi';
import { getTeamTickets } from '../../api/ticketApi';
import { getTeamMembers, getTeamPerformance } from '../../api/agentApi';
import StatsCard from '../../components/Dashboard/StatsCard';
import TicketList from '../../components/Tickets/TicketList';
import Loading from '../../components/Common/Loading';
import ErrorMessage from '../../components/Common/ErrorMessage';

export default function TeamLeadDashboard() {
  const [stats, setStats] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [performance, setPerformance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);

  useEffect(() => {
    fetchData();
  }, [statusFilter]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const [statsRes, ticketsRes, membersRes, perfRes] = await Promise.all([
        getDashboardStats(),
        getTeamTickets(statusFilter),
        getTeamMembers(),
        getTeamPerformance()
      ]);
      
      setStats(statsRes.stats);
      setTickets(ticketsRes.tickets);
      setTeamMembers(membersRes.team_members);
      setPerformance(perfRes.performance);
    } catch (err) {
      setError(err.response?.data?.msg || 'Failed to load dashboard');
    } finally {
      setLoading(false);
    }
  };

  if (loading && !stats) {
    return <Loading message="Loading team dashboard..." />;
  }

  if (error) {
    return <ErrorMessage message={error} onRetry={fetchData} />;
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Team Lead Dashboard</h1>
        <p>Monitor your team's performance and manage tickets</p>
      </div>

      <div className="stats-grid">
        <StatsCard
          title="Team Tickets"
          value={stats?.team_tickets || 0}
          icon="🎫"
          color="#667eea"
        />
        <StatsCard
          title="Open Tickets"
          value={stats?.open_tickets || 0}
          icon="📂"
          color="#ff9800"
        />
        <StatsCard
          title="In Progress"
          value={stats?.in_progress || 0}
          icon="⚙️"
          color="#2196f3"
        />
        <StatsCard
          title="Team Members"
          value={stats?.team_members || 0}
          icon="👥"
          color="#9c27b0"
        />
      </div>

      <div className="dashboard-section">
        <h2>Team Performance</h2>
        <div className="team-performance-grid">
          {performance.map((member) => (
            <div key={member.agent_id} className="performance-card">
              <h3>{member.agent_name}</h3>
              <div className="performance-stats">
                <div>
                  <span>Total:</span> <strong>{member.total_tickets}</strong>
                </div>
                <div>
                  <span>Closed:</span> <strong>{member.closed_tickets}</strong>
                </div>
                <div>
                  <span>Open:</span> <strong>{member.open_tickets}</strong>
                </div>
              </div>
              <span className={`status-badge ${member.status.toLowerCase()}`}>
                {member.status}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="dashboard-section">
        <TicketList
          tickets={tickets}
          loading={false}
          onStatusFilter={setStatusFilter}
        />
      </div>
    </div>
  );
}
